import {createApp} from 'vue'
import {createStore} from 'vuex'
import {createI18n} from 'vue-i18n'
import {createGtm} from '@gtm-support/vue-gtm'
import store from './store/store.js'
import {JsComponents, VueComponents} from './components/components'
import iShopEvents from './utilities/js/ishopEvents/ishopEvents.js'
import tooltipDirective from './utilities/vueDirectives/tooltipDirective/tooltipDirective'
import breakpointChangeEvent from './utilities/js/breakpointChangeEvent/breakpointChangeEvent.js'
import CookieMonster from './utilities/js/cookieMonster/cookieMonster'
import configureVeeValidate from './vee-validate/globalVeeValidationRules'

class App {
  constructor(name = 'novosales') {
    this.jsComponents = {};

    // initial cookie rejectAll
    const cookieConsent = CookieMonster.get('COOKIECONSENT');
    if (cookieConsent === undefined || cookieConsent === 'true' || cookieConsent === 'false') {
      CookieMonster.set(btoa(JSON.stringify(CookieMonster.rejectAll())));
    }

    const app = createApp({})

    const messages = {
      [window.__globalConfig.country || 'de']: window.__translations || {}
    };

    let i18n = createI18n({
      legacy: false,
      fallbackLocale: "de",
      locale: window.__globalConfig.country || 'de',
      warnHtmlInMessage: 'off', // disable of the Detected HTML in message
      warnHtmlMessage: false, // disable of the Detected HTML in message
      messages: messages,
    });
    app.use(i18n);

    configureVeeValidate(messages);

    const vuexAppStore = createStore(store)

    app.use(vuexAppStore);

    try { // consent manager not loading
      // enabled + loadScript have to be true
      let gtm = createGtm({
        id: window.__globalConfig.gtm,
        enabled: true,
        debug: false,
        loadScript: true,
        ignoredViews: []
      });
      app.use(gtm);
    } catch (e) {
      // noop
    }

    app.directive('tooltip', tooltipDirective);
    if (VueComponents) {
      // TODO: maybe filtering can be done better. teasers also need to be available globally.
      const componentsToRegister = VueComponents.filter(vueComponent =>
        !!document.querySelectorAll(`${vueComponent.name}, [is="${vueComponent.name}"]`).length
        || !!vueComponent.name.includes("teaser")
        || !!vueComponent.name.includes("slider")
      );

      for (const vueComponent of componentsToRegister) {
        app.component(vueComponent.name, vueComponent.constructor);
      }
    }

    iShopEvents();
    breakpointChangeEvent();

    app.config.compilerOptions.whitespace = "preserve"
    app.mount(`#${name}-app`)

    if (JsComponents) {
      for (const component of Array.from(JsComponents)) {
        const componentNodeElements = document.querySelectorAll(`.${component.name}`);

        for (const componentNodeElement of componentNodeElements) {
          if (!Object.prototype.hasOwnProperty.call(this.jsComponents, component.name)) {
            this.jsComponents[component.name] = [];
          }

          this.jsComponents[component.name].push(new component.constructor(componentNodeElement));
        }
      }
    }

  }

}

export default App;
